import React from 'react';
import { Level, Title } from 'rbx';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 1rem 1rem;
  border-bottom: 1px solid #f6f6f6;
`;

const Header = ({ history, isSubmitting, handleSubmit, hideSubmit }) => (
  <>
    <Wrapper>
      <Level>
        <Level.Item align="left">
          <Title className="is-size-2">Bulk Item Updates</Title>
        </Level.Item>
        <Level.Item
          align="right"
          style={{ padding: 0, marginTop: 0, marginBottom: 0 }}
        >
          <Level.Item>
            <a
              onClick={() => history.push('/bulk-menu-items/')}
              className="button is-grey"
            >
              <span className="has-text-weight-semibold">Cancel</span>
            </a>
          </Level.Item>
          {!hideSubmit && (
            <Level.Item>
              <button
                type="submit"
                className={`button is-primary ${isSubmitting && 'is-loading'}`}
                onClick={handleSubmit}
              >
                <span>Update Items</span>
              </button>
            </Level.Item>
          )}
        </Level.Item>
      </Level>
    </Wrapper>
  </>
);

export default Header;
